var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1819_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16455 6.50156C3.16455 6.06396 3.33839 5.64427 3.64782 5.33484C3.95726 5.0254 4.37694 4.85156 4.81455 4.85156H16.3646C16.8022 4.85156 17.2218 5.0254 17.5313 5.33484C17.8407 5.64427 18.0146 6.06396 18.0146 6.50156V14.7516C18.0146 15.1892 17.8407 15.6089 17.5313 15.9183C17.2218 16.2277 16.8022 16.4016 16.3646 16.4016H4.81455C4.37694 16.4016 3.95726 16.2277 3.64782 15.9183C3.33839 15.6089 3.16455 15.1892 3.16455 14.7516V6.50156Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16455 6.5L10.5896 11.45L18.0146 6.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1819_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8,
    height: 19.8,
    fill: "white",
    transform: "translate(0.689453 0.726562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.9426e78f870aa9d3b65f3f69a8fe7409.svg";
export { ForwardRef as ReactComponent };